import Vue from 'vue';
import {adminRoles} from '@/enums/userRolesEnum';
import HttpMixin from '@/mixins/HttpMixin';
import CreateTaskModal from '@/componentsReusable/tasks/create/CreateTaskModal';
import DelegatedTaskColumn from '@/componentsReusable/tasks/column/DelegatedTaskColumn';
import {Task} from '@/interfaces/TaskInterfaces';
import TaskModal from '@/componentsReusable/tasks/modal/TaskModal';
import {sortTask} from "@/utils/taskUtil";
import {ViewStateType} from "@/enums/ViewStateType";

export default Vue.extend({
  name: 'DelegatedTasks',
  props: {
    'userId': {type: [String, Number]}
  },
  components: {
    CreateTaskModal,
    TaskModal,
    DelegatedTaskColumn
  },
  mixins: [HttpMixin],
  data() {
    return {
      isAuthorized: false,
      showConfirmationModal: false,
      modalTaskId: 0,
      delegatedTaskData: [] as any[],
    };
  },
  computed: {
    delegatedTasks(): Task[] {
      return this.$store.state.task.delegatedTasks;
    },
    appUserId(): number {
      return this.$store.state.user.appUserId;
    }
  },
  watch: {
    delegatedTasks() {
      this.setTasks();
    }
  },
  created() {
    this.$store.commit('task/watchDelegated', true);
    this.setTasks();
  },
  beforeMount: function () {
    this.isAuthorized = this.$store.getters['user/hasRole'](adminRoles);
  },
  beforeDestroy() {
    this.$store.commit('task/watchDelegated', false);
    this.$store.commit('task/setDelegatedTasks', []);
  },
  methods: {
    getScreenStateKeyForDelegatedUser(delegatedUserId: number) {
      return ViewStateType.DELEGATED_TASKS_STATE + "_" + this.userId + "_" + delegatedUserId;
    },
    setTasks() {
      const taskMap = new Map<number, { assignedTo: number, tasks: Task[] }>();
      for (const task of this.delegatedTasks) {
        const assignedTo = task.assignedToAppUserId || (task.assignedToSecurityRoleId! * -1);
        let results = taskMap.get(assignedTo);
        if (!results) {
          results = { assignedTo: assignedTo, tasks: [] };
          taskMap.set(assignedTo, results);
        }
        results.tasks.push(task);
      }
      const toReturn = Array.from(taskMap.values())
        .sort((a, b) => {
          if (a.assignedTo < 0 && b.assignedTo < 0) {
            return (a.assignedTo * -1) - (b.assignedTo * -1);
          } else if (a.assignedTo < 0 || b.assignedTo < 0) {
            return b.assignedTo - a.assignedTo;
          } else {
            return a.assignedTo - b.assignedTo;
          }
        });
      toReturn.forEach(assignedTasks => assignedTasks.tasks.sort(sortTask));
      this.delegatedTaskData = toReturn;
    },
    createTask() {
      if (!this.showConfirmationModal) {
        this.showConfirmationModal = true;
      }
    },
    taskCreated(newTaskId: number) {
      this.modalTaskId = newTaskId;
      this.showConfirmationModal = false;
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/tasks/delegated/DelegatedTasks.ts